export * from './agreements.service';
import { AgreementsService } from './agreements.service';
export * from './companies.service';
import { CompaniesService } from './companies.service';
export * from './countries.service';
import { CountriesService } from './countries.service';
export * from './customers.service';
import { CustomersService } from './customers.service';
export const APIS = [AgreementsService, CompaniesService, CountriesService, CustomersService];
